import { createContext, useContext, useState } from 'react'
import PropTypes from 'prop-types'
import { ThemeProvider } from 'styled-components'

import { BRAND } from 'constants/appConstants'

const BrandContext = createContext()
const SCREEN_INFO_KEY = 'screenApp'

export const BrandProvider = ({ children }) => {
  const [brand, setBrand] = useState(
    localStorage.getItem(SCREEN_INFO_KEY) ? JSON.parse(localStorage.getItem(SCREEN_INFO_KEY)).brand : BRAND.ATH
  )

  return (
    <ThemeProvider theme={{ brand }}>
      <BrandContext.Provider value={{ setBrand: newBrand => setBrand(newBrand || BRAND.ATH) }}>
        {children}
      </BrandContext.Provider>
    </ThemeProvider>
  )
}

BrandProvider.propTypes = {
  children: PropTypes.any,
}

export const useBrand = () => useContext(BrandContext)
